class SocketIO {
  constructor (url, options = {}) {
    this.options = Object.assign({
      timer: 1000 * 50
    }, options)
    this.url = url
    this.attachFunctions = {}
    this.ws = null
    this.setIntervalWesocketPush = null
    this.createSocket(url)

    return this
  }
  // 发送数据
  send (message) {
    let Socket = this.ws
    if (Socket !== null && Socket.readyState === 3) {
      this.createSocket()
    } else if (Socket.readyState === 1) {
      Socket.send(JSON.stringify(message))
    } else if (Socket.readyState === 0) {
      this.connecting(message)
    }
  }

  // 发送数据但连接未建立时进行处理等待重发
  connecting (message, Socket = this.ws) {
    setTimeout(() => {
      if (Socket.readyState === 0) {
        this.connecting(message)
      } else {
        this.Socket.send(JSON.stringify(message))
      }
    }, 1000)
  }

  // 发送心跳
  sendPing (ping = 'ping') {
    clearInterval(this.setIntervalWesocketPush)
    this.ws.send(ping)
    this.setIntervalWesocketPush = setInterval(() => {
      this.ws.send(ping)
    }, this.options.timer)
  }

  // 关闭websocket
  close () {
    clearInterval(this.setIntervalWesocketPush)
    this.ws.close()
  }

  _notify (notifyName) {
    let args = Array.prototype.slice.call(arguments, 1)
    this.attachFunctions[notifyName] && this.attachFunctions[notifyName].fun.apply(this.attachFunctions[notifyName].scope, args)
    return this
  }

  on (notifyName, callback) {
    if (typeof notifyName === 'string' && typeof callback === 'function') {
      this.attachFunctions[notifyName] = {
        fun: callback,
        key: notifyName
      }
    }
    return this
  }

  createSocket (url, done = () => {}) {
    let that = this
    this.ws && this.close()
    this.ws = new WebSocket(url)
    this.ws.onopen = event => {
      that._notify('open', event)
      that.sendPing()
      done()
    }
    this.ws.onmessage = event => {
      that._notify('message', event)
    }
    this.ws.onclose = event => {
      console.log('链接被关闭')
      clearInterval(that.setIntervalWesocketPush)
      that._notify('close', event)
    }
    this.ws.onerror = event => {
      console.warn('发生异常了', that.ws)
      clearInterval(that.setIntervalWesocketPush)
      let reBootFlag = null
      if (that.ws.readyState !== 3) {
        reBootFlag = setInterval(() => {
          console.log('重连')
          that.createSocket(url, () => {
            clearInterval(reBootFlag)
          })
        }, 1000)
      } else {
        that.close()
      }
      that._notify('error', event)
    }
  }
}

export default SocketIO
